
let __scaned_callback__ = [];
let __scaning_callbacks__ = [];

export function __scaning(value) {
  __scaning_callbacks__.forEach(callback => {
    callback && callback(value);
  });
}

export function __scaned(value) {
  __scaned_callback__.forEach(callback => {
    callback && callback(value);
  });
}

export function onScaning(callback) {
  if (typeof callback == 'function'
    && __scaning_callbacks__.indexOf(callback) < 0) {
    __scaning_callbacks__.push(callback);
  }
}

export function offScaning(callback) {
  let indexOf = __scaning_callbacks__.indexOf(callback);
  if (typeof callback == 'function'
    && indexOf >= 0) {
    __scaning_callbacks__.splice(indexOf, 1)
  }
}

export function onScan(callback) {
  if (typeof callback == 'function'
    && __scaned_callback__.indexOf(callback) < 0) {
    __scaned_callback__.push(callback);
  }
}

export function offScan(callback) {
  let indexOf = __scaned_callback__.indexOf(callback);
  if (typeof callback == 'function'
    && indexOf >= 0) {
    __scaned_callback__.splice(indexOf, 1)
  }
}